import { render, staticRenderFns } from "./QuotaCalculator.vue?vue&type=template&id=c2b7f6e8&scoped=true&"
import script from "./QuotaCalculator.vue?vue&type=script&lang=js&"
export * from "./QuotaCalculator.vue?vue&type=script&lang=js&"
import style0 from "./QuotaCalculator.vue?vue&type=style&index=0&id=c2b7f6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b7f6e8",
  null
  
)

export default component.exports